<form
  [formGroup]="crownSectionForm"
  class="crown-section rx-app-flex-container-row"
  [class.read-only]="isReadOnly || (isCrownSectionDisabled$ | async)"
>
  <div class="crown-section__main rx-app-flex rx-app-flex-container-row rx-app-flex-container-row--justify-center">
    <div
      class="left-content rx-app-flex-container-row rx-app-flex-container-row--wrap rx-app-flex-container-row--justify-space-between"
    >
      <rx-select
        class="rx-app-flex--full"
        [id]="'material'"
        [label]="'ToothEditor.Material' | translate"
        [isRequired]="shouldValidateForSend$ | async"
        [isDisabled]="isCrownSectionDisabled$ | async"
        [isReadOnly]="isReadOnly"
        [formControl]="materialControl"
        [options]="materialOptions"
        name="materialControl"
      ></rx-select>
      <rx-select
          class="crown-section__design-select"
        [id]="'preparation-design-buccal'"
        [label]="'ToothEditor.PreparationDesign' | translate"
        [secondaryLabel]="'ToothEditor.Buccal' | translate"
        [isRequired]="(shouldValidateForSend$ | async) && materialOption?.PrepDesignMandatory"
        [formControl]="preparationDesignBuccalControl"
        [isDisabled]="!materialOption?.PrepDesignVisible"
        [isReadOnly]="isReadOnly"
        [options]="preparationDesignOptions"
        name="preparationDesignBuccalControl"
      ></rx-select>
      <rx-select
          class="crown-section__design-select"
        [id]="'preparation-design-lingual'"
        [label]="'ToothEditor.PreparationDesign' | translate"
        [secondaryLabel]="'ToothEditor.Lingual' | translate"
        [isRequired]="(shouldValidateForSend$ | async) && materialOption?.PrepDesignMandatory"
        [formControl]="preparationDesignLingualControl"
        [isDisabled]="!materialOption?.PrepDesignVisible"
        [isReadOnly]="isReadOnly"
        [options]="preparationDesignOptions"
        name="preparationDesignLingualControl"
      ></rx-select>
      <rx-select
          class="crown-section__design-select"
        [id]="'margin-design-buccal'"
        [label]="'ToothEditor.MarginDesign' | translate"
        [secondaryLabel]="'ToothEditor.Buccal' | translate"
        [isRequired]="(shouldValidateForSend$ | async) && materialOption?.MarginDesignMandatory"
        [formControl]="marginDesignBuccalControl"
        [isDisabled]="!materialOption?.MarginDesignVisible"
        [isReadOnly]="isReadOnly"
        [options]="marginDesignOptions"
        name="marginDesignBuccalControl"
      ></rx-select>
      <rx-select
          class="crown-section__design-select"
        [id]="'margin-design-lingual'"
        [label]="'ToothEditor.MarginDesign' | translate"
        [secondaryLabel]="'ToothEditor.Lingual' | translate"
        [isRequired]="(shouldValidateForSend$ | async) && materialOption?.MarginDesignMandatory"
        [formControl]="marginDesignLingualControl"
        [isDisabled]="!materialOption?.MarginDesignVisible"
        [isReadOnly]="isReadOnly"
        [options]="marginDesignOptions"
        name="marginDesignLingualControl"
      ></rx-select>
      <rx-select
          class="crown-section__design-select"
        *ngIf="(copyFromToothOptions$ | async)?.length && isToothClickedOnAPrep"
        [id]="'copy-from-tooth'"
        [label]="'ToothEditor.CopyFromTooth' | translate"
        [formControl]="copyFromToothControl"
		[isCancellable]="true"
        [isDisabled]="isCrownSectionDisabled$ | async"
        [isReadOnly]="isReadOnly"
		(cancelSelection)="handleCancelCopyFromToothSelection()"
        [options]="copyFromToothOptions$ | async"
        name="copyFromToothControl"
      ></rx-select>
    </div>
    <div class="right-content rx-app-flex-container-column">
      <rx-select
        [id]="'shade-system'"
        [label]="'ToothEditor.ShadeSystem' | translate"
        [isDisabled]="isShadeDisabled"
        [isReadOnly]="isReadOnly"
        [formControl]="shadeSystemControl"
        [options]="shadeSystemOptions"
        name="shadeSystemControl"
      ></rx-select>
        <ng-container *ngIf="!isOtherShadeSystemSelected">
            <rx-select
                [id]="'incisal'"
                [label]="'ToothEditor.Incisal' | translate"
                [isDisabled]="isShadeDisabled"
                [cleanOnDisable]="true"
                [isReadOnly]="isReadOnly"
                [formControl]="incisalControlAsIdName"
                [options]="incisalBodyGingivalOptions"
                name="incisalControl"
            ></rx-select>
            <rx-select
                [id]="'body'"
                [label]="'ToothEditor.Body' | translate"
                [isRequired]="(shouldValidateForSend$ | async) && materialOption?.BodyShadeMandatory"
                [isDisabled]="isShadeDisabled"
                [cleanOnDisable]="true"
                [isReadOnly]="isReadOnly"
                [formControl]="bodyControlAsIdName"
                [options]="incisalBodyGingivalOptions"
                name="bodyControl"
            ></rx-select>
            <rx-select
                [id]="'gingival'"
                [label]="'ToothEditor.Gingival' | translate"
                [isDisabled]="isShadeDisabled"
                [cleanOnDisable]="true"
                [isReadOnly]="isReadOnly"
                [formControl]="gingivalControlAsIdName"
                [options]="incisalBodyGingivalOptions"
                name="gingivalControl"
            ></rx-select>

        </ng-container>
        <ng-container *ngIf="isOtherShadeSystemSelected">
            <div>
                <rx-text-input
                    [label]="'ToothEditor.Incisal' | translate"
                    [formControl]="incisalControl"
                    [isDisabled]="isShadeDisabled || isReadOnly"
                    [maxlength]="maxInputLengthForOtherShadeSystem"
                    autocomplete="off"
                    [name]="'incisalControl'"
                ></rx-text-input>
            </div>
            <div>
                <rx-text-input
                    [label]="'ToothEditor.Body' | translate"
                    [formControl]="bodyControl"
                    [isDisabled]="isShadeDisabled || isReadOnly"
                    [required]="materialOption?.BodyShadeMandatory && (shouldValidateForSend$ | async)"
                    [maxlength]="maxInputLengthForOtherShadeSystem"
                    autocomplete="off"
                    [name]="'bodyControl'"
                ></rx-text-input>
            </div>
            <div>
                <rx-text-input
                    [label]="'ToothEditor.Gingival' | translate"
                    [formControl]="gingivalControl"
                    [isDisabled]="isShadeDisabled || isReadOnly"
                    [maxlength]="maxInputLengthForOtherShadeSystem"
                    autocomplete="off"
                    [name]="'gingivalControl'"
                ></rx-text-input>
            </div>
        </ng-container>

      <rx-select
        [id]="'stump-shade'"
        [label]="'ToothEditor.StumpShade' | translate"
        [isRequired]="(shouldValidateForSend$ | async) && materialOption?.StumpShadeMandatory"
        [isDisabled]="!materialOption?.StumpShadeVisible"
        [cleanOnDisable]="true"
        [isReadOnly]="isReadOnly"
        [formControl]="stumpShadeControl"
        [options]="stumpShadeOptions"
        name="stumpShadeControl"
      ></rx-select>
    </div>
  </div>
</form>
